<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px" lazy>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline"
              >{{ type === "new" ? "Criar " : "Editar " }}Usuário</span
            >
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newUser.name"
                    label="Nome"
                    required
                    :readonly="type === 'edit'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4 v-if="type === 'new'">
                  <v-text-field
                    v-model="newUser.displayName"
                    label="Nome exibição"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newUser.email"
                    label="E-mail"
                    required
                    :readonly="type === 'edit'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="newUser.group"
                    :items="newGroupList ?? groupList"
                    label="Grupos"
                    multiple
                    chips
                    persistent-hint
                    item-text="label"
                    item-value="value"
                    @click="toggle"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-autocomplete
                    v-model.lazy="newUser.partner_id"
                    :items="partners"
                    item-text="name"
                    item-value="id"
                    label="Parceiro"
                    required
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md4 v-if="isSalesPartner">
                  <v-text-field v-model="newUser.whatsapp" label="Whatsapp" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog = false"
              >Fechar</v-btn
            >
            <v-btn
              color="blue darken-1"
              flat
              @click.prevent="validate()"
              :loading="loading"
              :disabled="loading"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import { eventBus } from "@/main";
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    valid: false,
    loading: false,
    dialog: false,
    type: "new",
    newUser: {
      email: null,
      name: null,
      emailVerified: true,
      displayName: null,
      disabled: false,
      group: [],
      partner_id: null,
      whatsapp: null,
    },
    newGroupList: null,
    customer_id: null,
  }),

  computed: {
    ...mapState("configuration", ["user", "partners"]),
    ...mapState(["groupList"]),

    likesAllGroups() {
      return this.newUser.group.length === this.groupList.length;
    },

    likesSomeGroups() {
      return this.newUser.group.length > 0 && !this.likesAllGroups;
    },

    icon() {
      if (this.likesAllGroups) return "mdi-close-box";
      if (this.likesSomeGroups) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    isSalesPartner() {
      let userGroups = this.newUser.group.toString();
      return (
        userGroups.indexOf("sales_partner") >= 0 ||
        userGroups.indexOf("sales_partner_management") >= 0
      );
    },
  },

  mounted() {
    this.getPartners();

    eventBus.$on("userForm", (obj) => {
      if (obj.type === "edit" && this.user) {
        this.customer_id = this.user.customer_id;
        this.newUser.name = this.user.name;
        this.newUser.email = this.user.email;
        this.newUser.displayName = this.user.displayName;
        this.newUser.group = this.user.group;
        this.newUser.partner_id = this.user.partner_id;
        this.newUser.whatsapp = this.user.whatsapp ?? null;
      } else if (obj.type === "new") {
        this.newUser.name = null;
        this.newUser.email = null;
        this.newUser.displayName = null;
        this.newUser.partner_id = null;
        this.newUser.group = [];
        this.newUser.whatsapp = null;
      }
      if (!obj.isAdmin) {
        this.newGroupList = this.groupList.filter(
          (group) => group.value !== "admin",
        );
      }
      this.type = obj.type;
      this.dialog = obj.status;
    });
  },

  methods: {
    ...mapActions("configuration", ["getPartners", "addUser", "modifyUser"]),

    toggle() {
      this.$nextTick(() => {
        if (this.likesAllGroups) {
          this.newUser.group = [];
        } else {
          this.newUser.group = this.groupList.slice().map((item) => item.value);
        }
      });
    },

    async validate() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.valid = true;
        if (this.type === "new") {
          let data = {
            ...this.newUser,
            customClaims: {
              group: this.newUser.group,
              partner: this.newUser.partner_id,
            },
          };
          await this.addUser(data);
        } else if (this.type === "edit") {
          let data = {
            id: this.customer_id,
            group: this.newUser.group,
            partner_id: this.newUser.partner_id,
          };
          await this.modifyUser(data);
        }
        this.loading = false;
      }
    },
  },
};
</script>
